import { useQuery } from '@tanstack/react-query';
import { fetch_dashboard_stats, fetch_reports, fetch_transactions } from './api';
import type { ReportRange, TxRange } from './types';

const DASHBOARD_STATS_KEY = ['vendor-stats', 'dashboard'] as const;

export function use_dashboard_stats() {
  return useQuery({ queryKey: DASHBOARD_STATS_KEY, queryFn: fetch_dashboard_stats });
}

export function use_reports(range: ReportRange) {
  return useQuery({ queryKey: ['vendor-stats', 'reports', range] as const, queryFn: () => fetch_reports(range) });
}

export function use_transactions(range: TxRange) {
  return useQuery({ queryKey: ['vendor-stats', 'transactions', range] as const, queryFn: () => fetch_transactions(range) });
}
